import React, { useEffect } from "react";
import HeroSection from "../../Components/userComponents/HomeComponents/HeroSection";
import FeaturedCourses from "../../Components/userComponents/HomeComponents/FeaturedCourses";
// import FeaturedInstructor from "../../Components/userComponents/HomeComponents/FeaturedInstructor";
import TrustedBy from "../../Components/userComponents/HomeComponents/TrustedBy";
import WantToShare from "../../Components/userComponents/HomeComponents/WantToShare";
import OurTestimonials from "../../Components/userComponents/HomeComponents/OurTestimonials";
import MasterTheSkills from "../../Components/userComponents/HomeComponents/MasterTheSkills";
import UnlockYour from "../../Components/userComponents/HomeComponents/UnlockYour";
import LatestTechBlogs from "../../Components/userComponents/HomeComponents/LatestTechBlogs";
import BecomeAnInstructor from "../../Components/userComponents/HomeComponents/BecomeAnInstructor";
import WhatsappComponent from "../../Components/userComponents/messagesmodal/WhatsappComponen";
import CallButtonComponent from "../../Components/userComponents/messagesmodal/CallButtonComponent";
import Slider from "../../Components/userComponents/Common/Slider";
import TechSlider from "../../Components/userComponents/Common/TechSlider";
import AOS from "aos";
import "aos/dist/aos.css";

const Home = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      offset: 100,
      delay: 200,
    });
  }, []);

  return (
    <div className="overflow-x-hidden">
      <HeroSection />
      <Slider />
      <UnlockYour />
      <FeaturedCourses />
      <MasterTheSkills />
      <TrustedBy />
      <WantToShare />
      <TechSlider />
      <OurTestimonials />
      <LatestTechBlogs />
      {/* <FeaturedInstructor /> */}
      <BecomeAnInstructor />
      <WhatsappComponent />
      <CallButtonComponent />
    </div>
  );
};

export default Home;
